export default __webpack_public_path__ + "static/media/4 AP Sardeigne MARCHIO VERTICALE.8b61776d.jpg";